import pdf from 'vue-pdf'


export default pdf


